export default {
  status: {
    open: 'Avoinna',
    closed: 'Suljettu',
  },
  offline_until: 'Offline kunnes',
  closed_until: 'Suljettu kunnes',
  online_orders_paused: 'Verkkotilaukset keskeytetty',
  online_orders_paused_until: 'Verkkotilaukset keskeytetty kunnes',
  reopens: 'Avautuu uudelleen',
  opens_today: 'Avautuu tänään',
  opens: 'Avautuu',
  open: 'Avoinna',
  open_whole_day: 'Avoinna koko päivän',
  outside_ordering_times: 'Tilausaikojen ulkopuolella',
};
